import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import * as z from "zod";

export const exportEnrichedBalanceTransactions = {
  name: "exportEnrichedBalanceTransactions" as const,
  input: AdvancedFilterInputSchema,
  output: z.object({ downloadUrl: z.string(), filename: z.string() }),
};
